module.exports = __webpack_public_path__ + "img/nuiteqLogo.1454bda2.svg";